<template>
  <v-dialog
    :value="dialog"
    @input="$emit('input', $event)"
    persistent
    fullscreen
  >
    <v-card>
      <v-toolbar width="100%" color="primary" class="mb-4">
        <v-spacer />
        <v-toolbar-items>
          <v-btn text class="white--text" @click="close">
            Cancelar
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <p>Se recomienda utilizar la última versión de Google Chrome para obtener los mejores resultados.</p>
        <video v-show="!showSnapshotCanvas" width="100%" ref="cameraFeed" id="camera-feed" autoplay />
        <canvas  v-show="showSnapshotCanvas" class="full-width" ref="snapshotCanvas" id="snapshot-canvas" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn v-show="!showSnapshotCanvas" large color="primary" @click="snapPicture">
            <v-icon color="white">mdi-camera</v-icon>
        </v-btn>
        <v-btn v-show="showSnapshotCanvas" large color="white" @click="retryPicture">
          <v-icon color="primary">mdi-undo</v-icon>
        </v-btn>
        <v-btn v-show="showSnapshotCanvas" large color="primary" @click="approvePicture">
          <v-icon color="white">mdi-upload</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {type: Boolean, required: true},
  },

  data: () => ({
    imgCapture: null,
    stream: null,
    showSnapshotCanvas: false,

    snapshot: null,
    snapshotBitmap: null,
    contentType: 'image/png'
  }),

  watch: {
    dialog: function (newVal) {
      if (newVal) { 
        this.setStream() 
      } else {
        this.stopStream()
      }
    }
  },

  methods: {
    close() {
      this.$emit("close-dialog");
    },

    setStream() {
      navigator.mediaDevices
        .getUserMedia({
          audio: false,
          video: {
            facingMode: "environment",
          },
        })
        .then((stream) => {
          if (window.ImageCapture) {
            const track = stream.getVideoTracks()[0];
            this.imgCapture = new ImageCapture(track);
          }

          this.stream = stream;
          this.$refs.cameraFeed.srcObject = stream;
        })
        .catch((err) => {
          console.log(`Could not access the camera: ${err}`);
          console.error(err);
        });
    },

    snapPicture() {
      if (this.imgCapture) {
        this.snapPictureImgCapture()
      } else {
        this.snapPictureCanvas()
      }
    },

    snapPictureImgCapture() {
      this.imgCapture
        .takePhoto()
        .then((blob) => {
          this.snapshot = this.blobToFile(blob);
          return createImageBitmap(blob);
        })
        .then((bitmap) => {
          this.drawCanvas(this.$refs.snapshotCanvas, bitmap);
          this.showSnapshotCanvas = true
        })
        .catch((err) => console.error(err));
    },

    snapPictureCanvas() {
      const width = this.$refs.cameraFeed.videoWidth;
      const height = this.$refs.cameraFeed.videoHeight

      this.$refs.snapshotCanvas.width = width;
      this.$refs.snapshotCanvas.height = height;

      const context = this.$refs.snapshotCanvas.getContext("2d");
      context.drawImage(this.$refs.cameraFeed, 0, 0, width, height); 

      const dataURL = this.$refs.snapshotCanvas.toDataURL("image/png")
      this.dataURLToBlob(dataURL).then(blob => { this.snapshot = this.blobToFile(blob) })
      this.showSnapshotCanvas = true
    },

    retryPicture() {
      this.showSnapshotCanvas = false
    },

    approvePicture () {
      this.$emit("assign-photo", this.snapshot)
    },

    drawCanvas(canvas, img) {
      const video = this.$refs.cameraFeed

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      let ratio = Math.min(
        canvas.width / img.width,
        canvas.height / img.height
      );
      let x = (canvas.width - img.width * ratio) / 2;
      let y = (canvas.height - img.height * ratio) / 2;

      const context = canvas.getContext('2d')

      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(
        img,
        0,
        0,
        img.width,
        img.height,
        x,
        y,
        img.width * ratio,
        img.height * ratio
      );
    },

    stopStream() {
      this.stream.getTracks().forEach(track => { track.stop() });
      this.$refs.cameraFeed.srcObject = null;
    },

    async dataURLToBlob (base64DataURL) {
      return await fetch(base64DataURL).then(it => it.blob())
    },

    blobToFile(blob) {
      const formatDate = date => date.toISOString().replace(/T.*/,'').split('-').reverse().join('-')

      const today = new Date()
      const filename = `nueva-factura-${formatDate(today)}.png`

      return new File([blob], filename, {type: this.contentType, lastModified: today.getTime()})
    }
  },
}
</script>

<style scoped>
.full-width {
  width: 100%;
}
</style>
